import { AppDispatch } from "../store/types";
import { useDispatch } from "react-redux";

export const useAppDispatch: () => AppDispatch = useDispatch;
